export enum DownloadType {
  All = '',
  SEARCHED_ASSETS = 'searchedAssets',
}
